module.exports = __webpack_public_path__ + "img/trash.781e944b.svg";